<template>
  <section class="container items-container">
    <div class="row">
      <div class="col-12 col-md-6" v-for="card in cardList">
        <Cards :title="card.title" :link="card.link" :hasButton="card.hasButton"></Cards>
      </div>
      <!-- /.col-12 col-md-3 -->
    </div>
    <!-- /.row -->
  </section>
  <!--== /.container ==-->
</template>

<script>
  import Cards from '../generic/Cards.vue';

  export default {
    name: 'Items',
    data () {
      return {
        cardList: [
          {
            title: 'Atos Oficiais',
            link: '/gestaoegovernanca/atosoficiais',
            hasButton: true
          },
          {
            title: 'Organograma',
            link: '/gestaoegovernanca/organograma',
            hasButton: true
          }
        ]
      }
    },
    components: {
      Cards
    }
  };
</script>

<style scoped lang="scss">
  .items-container {
    margin-top: 30px;
  }
</style>
